import React from "react";

export default function Web_Google_Maps() {
  return (
    <div>
      <h1>What is Google Maps</h1>
      <p>
        Route: <code>/web/google-maps</code>
      </p>
      <p>Auto-generated component.</p>
    </div>
  );
}
